import { T_FAQ_PAGE_CONSTANTS } from './TYPES'

const EN_FAQ_PAGE_CONSTANTS: T_FAQ_PAGE_CONSTANTS = {
  PAGE_KICKER: 'HELP YOURSELF WITH',
  PAGE_TITLE: 'Frequently Asked Questions',
  FAQ_CATEGORIES: [
    {
      categoryName: 'General',
      faqs: [
        {
          question: 'What is the purpose of this app?',
          answer:
            'This app is designed to promote reading among children in a playful and engaging way. Children, referred to as adventurers, read books offline and complete quizzes based on what they’ve read. By doing so, they earn points that help their mascot, a griffon named Griffy, level up and evolve, adding a fun and rewarding element to the reading experience. The app distinguishes between child and adult users. Adventurers can play solo, join reading events or competitions, and connect with friends by sending friend requests. They can also view each other’s personal libraries, encouraging the exchange of books and fostering a sense of community around reading. Adult users, on the other hand, can upload quizzes to the platform and organize reading events or competitions for adventurers. This collaborative setup supports both guided and independent reading, making the app a versatile tool for encouraging a lifelong love of books.'
        },
        {
          question: 'Who can use this app?',
          answer:
            'The app can be used by both adults and children (called adventurers).'
        },
        {
          question: 'What can an adult do on the platform?',
          answer:
            'Adults - parents, teachers - can upload book quizzes which will help expand the library of educational content. They can also create reading competitions or events for a group of children to encourage reading while also tracking their progress and achievements.'
        },
        {
          question: 'What can a child (adventurer) do on the platform?',
          answer:
            'Children can take quizzes, rate and track books, manage their library and interact with friends. They can participate in 3 game modes: solo adventure, invitation-based competitions and public events.'
        },
        {
          question:
            'How can I create an account for myself and for my child(ren)?',
          answer:
            'You can create an account by entering your full name, date of birth, preferred language, email address and a 6-digit password. Once your account is set up, you can add an account for your child(ren) by clicking on the “Add a child” button and providing their full name, date of birth, preferred language, username and a 6-digit password.'
        }
      ]
    },
    {
      categoryName: 'Account and Subscription',
      faqs: [
        {
          question: 'Is there a subscription fee?',
          answer:
            'The platform is free for adults. A small subscription fee is required to unlock the platform for children. Several subscription plans are available, depending on the number of children to be subscribed and the length of the subscription. The payment is processed through PayPal. The platform is available free of charge during the beta testing period.'
        },
        {
          question: 'Is there a free trial period for children?',
          answer:
            'Yes, there is a 15-day trial period for children after which an adult will have to subscribe the child to a subscription plan.'
        },
        {
          question: 'What are the benefits of subscribing?',
          answer:
            'Subscribing unlocks the full features of the platform, including the ability to participate in competitions, view leaderboards, and receive badges for top rankings.'
        }
      ]
    },
    {
      categoryName: 'Gameplay and Features',
      faqs: [
        {
          question: 'How do quizzes work?',
          answer:
            "The quizzes are multiple-choice tests aimed at assessing the comprehension of the text of a book read offline. Each quiz consists of 5 questions, with three answer options per question: one correct and two incorrect. Points can be earned by selecting the correct answer (5 points per question, with a maximum of 25 points per quiz), which contribute to the character's experience, leading to leveling up and evolution of his or her Griffy."
        },
        {
          question: 'Can children compete with each other?',
          answer:
            'Yes, adults can create competitions for their children to participate in. Rankings are displayed on the leaderboard, and badges are awarded to top rankers. Children can also compete in events organized by the platform.'
        },
        {
          question: 'How can children become friends on the platform?',
          answer:
            'Children can add other children to their friends list. They can also view the books owned by their friends to facilitate offline contact and discussions.'
        }
      ]
    },
    {
      categoryName: 'Book and Reading',
      faqs: [
        {
          question: 'Can children indicate in the app which books they own?',
          answer:
            'Children can indicate the books available in their home library in the “My Library” section of the app. This allows their friends to see their books and they can arrange to lend books to one another.'
        },
        {
          question: 'Can the books be read within the app?',
          answer:
            'No, the app does not contain any books, only the quizzes based on them. Children read the books offline and then take the quizzes based on them within the app.'
        }
      ]
    },
    {
      categoryName: 'Technical Support',
      faqs: [
        {
          question: 'I forgot my username. What should I do?',
          answer:
            'You can know your username by clicking on the "Forgot Username" link on the login page and following the instructions.'
        },
        {
          question: 'I forgot my password. What should I do?',
          answer:
            'You can reset your password by clicking on the "Forgot Password" link on the login page and following the instructions.'
        },
        {
          question: 'How do I contact customer support?',
          answer:
            'For any issues or questions, you can contact our customer support team through the help section in the app or by emailing contact@griffyreads.com.'
        }
      ]
    }
  ]
}

export default EN_FAQ_PAGE_CONSTANTS
